// extracted by mini-css-extract-plugin
module.exports = {"root":"FormGroup_root__l4C0n","legend":"FormGroup_legend__3npU3"};